export enum EPlatformNames {
  twitch = 'twitch',
  youtube = 'youtube',
  tiktok = 'tiktok',
  kick = 'kick',
}

export enum EPlatformReadableNames {
  twitch = 'Twitch',
  youtube = 'YouTube',
  tiktok = 'TikTok',
  kick = 'Kick',
}

export interface IConnectedAccount {
  link?: string;
  type: EPlatformNames;
  name: string;
  is_destination: boolean;
  is_connected: boolean;
}

export interface IPlatformStreamInfo {
  title?: string;
  description?: string;
}

export interface IStreamInfo extends Record<EPlatformNames, IPlatformStreamInfo | undefined> {
  general: {
    title: string | null;
    description: string | null;
  };
}

export type TAuthIntent = 'reauth' | 'link';

export function buildAuthUrl(platform: EPlatformNames, intent: TAuthIntent): string {
  return `/auth/${platform}?intent=${intent}`;
}
